export default "__VITE_ASSET__2ec9af53__"